import { Component, OnInit, ViewContainerRef, ComponentFactoryResolver, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { LabDataService } from '../data-services/lab.service';
import { ClientListComponent } from '../modules/client/client.list';
import { SecurityService, SecurityUser } from '../security/security.service';
import { UserListComponent } from '../modules/user/user.list';
import { AccordionModule } from 'primeng/accordion';
import { CommonModule } from '@angular/common';
import { AngularSplitModule } from 'angular-split';
import { HasClaimDirective } from '../security/has-claim.directive';

@Component({
   selector: 'app-labadmin',
   templateUrl: './labadmin.html',
   styleUrls: ['./labadmin.css'],
   imports: [AccordionModule, CommonModule, RouterModule, AngularSplitModule, HasClaimDirective]
})
export class LabAdminComponent implements OnInit {
  currentUser: SecurityUser = new SecurityUser();
  constructor(private securityService: SecurityService,
    private router: Router)
  {
    this.securityService.getCurrentUser().subscribe((usr: any) => {
      if (!usr.IsAuthenticated) {
        this.router.navigate(['']);
      }
      this.currentUser = usr;
    });
  }
   
  loading: boolean;
  isAuthenticated: boolean;
  showIframeHider = false;
  //treenodes: any[];
  //treeoptions: any;
   //treedata: TreeNode[];
  viewURI: string = null;
  curitem;
  selid: number;
  seltype: string;
  viewref: any = null;
  tests: any;
  users: any;
  selnode;

  @ViewChild('container', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;    

  async ngOnInit() {
    this.loading = true;

    //this.labDataService.getLabList().subscribe((data: any) => {
    //  this.treenodes = data.map(lab => <any>{
    //    "name": lab.LabName,
    //    "id": 'l,' + lab.Id,
    //    "hasChildren": true,
    //    "icon": "fa-flask"
    //  });
    //});

    //this.loadLabs();
    //this.doTestSearch();

  //  this.treeoptions = {
  //      getChildren: (node: TreeNode) => {
  //        return this.loadNodeChildren(node);
  //      }
  //  }
  }

   //loadLabs() {
   //   this.labDataService.getLabList().subscribe((data: any) => {
   //      this.treenodes = data.map(lab => <any>{
   //         "name": lab.LabName,
   //         "id": 'l,' + lab.Id,
   //         "hasChildren": true,
   //         "icon": "fa-flask"
   //      });
   //   });
   //}
   
  public showUserList() {
    if (this.viewref != null) {
      this.viewref.destroy();
    }
    this.viewref = this.viewContainerRef.createComponent(UserListComponent);
    this.viewref.changeDetectorRef.detectChanges();
  }

  public showClientList() {
    if (this.viewref != null) {
      this.viewref.destroy();
    }
    this.viewref = this.viewContainerRef.createComponent(ClientListComponent);
    this.viewref.changeDetectorRef.detectChanges();
  }

  //public createTestOrders() {
  //  if (this.viewref != null) {
  //    this.viewref.destroy();
  //  }
  //  const factory = this.componentFactoryResolver.resolveComponentFactory(TestOrdersComponent);
  //  this.viewref = this.viewContainerRef.createComponent(factory);
  //  this.viewref.changeDetectorRef.detectChanges();
  //}

  // public showLab(item, id, labtree) {
  //    var keys = id.split(",");
  //    this.seltype = keys[0];
  //    this.selid = keys[1];
  //    this.curitem = item;

  //    if (this.viewref != null) {
  //       this.viewref.destroy();
  //    }

  //    if (this.seltype == "l") {
  //       const factory = this.componentFactoryResolver.resolveComponentFactory(LabEditComponent);
  //       this.viewref = this.viewContainerRef.createComponent(factory);
  //       this.viewref.instance.getLab(this.selid);
  //       this.viewref.instance.operationComplete.subscribe($event => {
  //          this.loadLabs();
  //       });
  //       this.viewref.changeDetectorRef.detectChanges();

  //    } else if (this.seltype == "p") {
  //       const factory = this.componentFactoryResolver.resolveComponentFactory(PanelEditComponent);
  //       this.viewref = this.viewContainerRef.createComponent(factory);
  //       this.viewref.instance.labid = keys[2];
  //       this.viewref.instance.getPanel(this.selid);
  //       this.viewref.instance.operationComplete.subscribe($event => {
  //          this.reloadTreeNodeChildren('l,' + keys[2], labtree);
  //       });
  //       this.viewref.changeDetectorRef.detectChanges();

  //    } else if (this.seltype == "t") {
  //       if (this.selid == 0)
  //       {
  //          this.linkTestPanelId = keys[2];
  //          this.linkTestLabId = keys[3];
  //          this.doLinkTestSearch();
  //          this.linkTestVisible = true;
  //       }
  //       else
  //       {
  //          const factory = this.componentFactoryResolver.resolveComponentFactory(TestEditComponent);
  //          this.viewref = this.viewContainerRef.createComponent(factory);
  //          this.viewref.instance.panelid = keys[2];
  //          this.viewref.instance.getTest(this.selid);
  //          this.viewref.instance.operationComplete.subscribe($event => {
  //             this.reloadTreeNodeChildren('p,' + keys[2] + ',' + keys[3], labtree);
  //          });
  //          this.viewref.changeDetectorRef.detectChanges();
  //       }
  //    }
  // }

  // public createNewTest() {
  //    this.seltype = 't';
  //    this.selid = 0;

  //    if (this.viewref != null) {
  //       this.viewref.destroy();
  //    }

  //    const factory = this.componentFactoryResolver.resolveComponentFactory(TestEditComponent);
  //    this.viewref = this.viewContainerRef.createComponent(factory);
  //    this.viewref.instance.getTest(this.selid);
  //    this.viewref.instance.operationComplete.subscribe($event => {
  //       this.doTestSearch();
  //    });
  //    this.viewref.changeDetectorRef.detectChanges();
  // }

  // reloadTreeNodeChildren(id, labtree) {
  //    labtree.treeModel.getNodeById(id).loadNodeChildren();
  // }

  // public treeNodeActivated(eventArgs: { eventName: string, node: TreeNode }, labtree): void {
  //    if (!eventArgs.eventName || !eventArgs.node) {
  //       return;
  //    }
  //    this.showLab(eventArgs.node, eventArgs.node.id, labtree);
  // }

  // public loadNodeChildren(node) {
  //    var keys = node.id.split(",");

  //    if (keys[0] == "l") {
  //       return this.labDataService.getPanelsForLab(keys[1]).toPromise().then((data: any) => {
  //          var children = data.map(lab => <any>{
  //             "name": lab.Name,
  //             "id": 'p,' + lab.Id + ',' + keys[1],
  //             "hasChildren": true,
  //             "icon": "fa-tasks"
  //          });

  //          children.unshift(<any>{
  //             "name": "Add New Panel",
  //             "id": 'p,0' + ',' + keys[1],
  //             "hasChildren": false,
  //             "icon": "fa-plus"
  //          });
  //          return children;
  //       });
  //    } else if (keys[0] == 'p') {
  //       return this.labDataService.getTestsForPanel(keys[1]).toPromise().then((data: any) => {
  //          var children = data.map(test => <any>{
  //             "name": test.Name,
  //             "id": 't,' + test.Id + ',' + keys[1] + ',' + keys[2],
  //             "hasChildren": false,
  //             "icon": "fa-check-square"
  //          });

  //          children.unshift(<any>{
  //             "name": "Add New Test",
  //             "id": 't,0,' + keys[1] + ',' + keys[2],
  //             "hasChildren": false,
  //             "icon": "fa-plus"
  //          });
  //          return children;
  //       });
  //    }
  // }

  // testSearchString: string = "";
  // public doTestSearch() {
  //    this.labDataService.searchTests(this.testSearchString).subscribe((data: any) => {
  //      this.tests = [];
  //      for (var i = 0; i < data.length; i++) {
  //          this.tests.push(data[i]);
  //      }
  //    });
  // }

  // linkTestLabId: number;
  // linkTestPanelId: number;
  // linkTests: any;
  // linkTestSearchString: string = "";
  // linkTestVisible: boolean = false;

  // public doLinkTestSearch() {
  //    this.labDataService.searchTests(this.linkTestSearchString).subscribe((data: any) => {
  //       this.linkTests = [];
  //       for (var i = 0; i < data.length; i++) {
  //          this.linkTests.push(data[i]);
  //       }
  //    });
  // }

  // public addPanelTestLink(testId, labtree) {
  //    this.labDataService.addTestPanelLink(this.linkTestPanelId, testId).subscribe((data: any) => {
  //      this.reloadTreeNodeChildren('p,' + this.linkTestPanelId + ',' +  this.linkTestLabId, labtree);
  //      this.linkTestVisible = false;
  //    });
  //}

  onTabOpen(event) {
    console.log('admin tab', event);
    var name = event.originalEvent.srcElement.textContent;
    if (name === ' Users ') {
      this.showUserList();
    } else if (name === ' Clients ') {
      this.showClientList();
    }
  }
}
